import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CanvasWhiteboardComponent, CanvasWhiteboardOptions, CanvasWhiteboardService, CanvasWhiteboardShapeService, CircleShape, LineShape, RectangleShape, SmileyShape, StarShape } from 'ng2-canvas-whiteboard';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ClientAction } from '../../../models/file-upload/file-data';
import { RequestModel } from '../../../models/request/request-model';
import { DialogType, ResponseStatus } from '../../../shared/components/sem-dynamic/sem-dynamic.component';
import { DynamicLoadingUtil } from '../../../shared/helpers/dynamic-loading-util';
import { SemConfirmDialogComponent } from '../dialogs/sem-confirm-dialog/sem-confirm-dialog.component';
import { ValueAccessorBase } from '../shared/value-accessor/value-accessor-base';

@Component({
  selector: 'sem-sign-control',
  templateUrl: './sem-sign-control.component.html',
  styleUrls: ['./sem-sign-control.component.css'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: SemSignControlComponent, multi: true }
  ]
})
export class SemSignControlComponent extends ValueAccessorBase<any> implements OnInit, AfterViewInit, OnDestroy {
  ngOnDestroy(): void {
    this.actionFinishedSubscription.unsubscribe();
  }

  @Input() formActionName: string = "";
  @Input() instructionLabel: string = "";
  @Input() sucessLabel: string = "";

  drawingEnabled: boolean = true;
  @Output() saveFormReq = new EventEmitter<string>();
  @Output() refCD = new EventEmitter<string>();
  private previewApiUrl: string = "api/media/GetPreview";
  base64: any;
  btnEnabled: boolean = true;
  drawn: boolean = false;
  message: string = "";

  canvasOptions: CanvasWhiteboardOptions = {
    drawButtonEnabled: false,
    drawButtonClass: "drawButtonClass",
    drawButtonText: "Draw",
    clearButtonEnabled: false,
    clearButtonClass: "clearButtonClass",
    clearButtonText: "Clear",
    undoButtonText: "Undo",
    undoButtonEnabled: false,
    redoButtonText: "Redo",
    redoButtonEnabled: false,
    colorPickerEnabled: false,
    showShapeSelector: false,
    fillColorPickerText: "Fill",
    strokeColorPickerText: "Stroke",
    strokeColorPickerEnabled: false,
    saveDataButtonEnabled: false,
    saveDataButtonText: "Save",
    lineWidth: 5,
    strokeColor: "rgb(0,0,0)",
    shouldDownloadDrawing: false
  };
  @ViewChild(CanvasWhiteboardComponent)
  canvasWhiteboardComponent: CanvasWhiteboardComponent;

  actionFinishedSubscription: Subscription;


  ngAfterViewInit() {
    this.canvasWhiteboardComponent.drawingEnabled = true;
    this.loading = true;

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 1);

    this.actionFinishedSubscription = this.actionsService.currentActionFinished.subscribe(value => {
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 1);
    });
  }

  saveImg($event: any) {
    this.message = "";
    DynamicLoadingUtil.loader.showLoader = true;
    this.drawingEnabled = false;
    this.canvasWhiteboardComponent.drawingEnabled = false;
    this.canvasWhiteboardComponent.generateCanvasBlob(this.receiveBlob.bind(this), 'image/png', 1);
  }

  receiveBlob(blob: any) {
    if (this.drawn) {
      this.loading = true;
      let file = new File([blob], "signature.png");
      let fileData = this.mapItem(file, ClientAction.New, undefined, null, 4);

      this.blob2base64(blob, 'image/png').then(base64 => {
        this.model.Base64Signature = base64;
        //this.fileUploadService.files.push(fileData); 

        if(!this.formActionName || this.formActionName.length == 0){
          this.formActionName = "GenerateEBikeFormPdf";
        }

        this.actionsService.getActionAndExecute(this.formActionName, false, this, true, false, this.model, this.afterActionFinished.bind(this));
      });
    } else {
      this.drawingEnabled = true;
      this.canvasWhiteboardComponent.drawingEnabled = true;
      DynamicLoadingUtil.loader.showLoader = false;
      this.loading = false;
      this.message = this.instructionLabel;

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 1);
    }

    //this.saveFormReq.emit("");
  }

  afterActionFinished(data: any) {
    this.btnEnabled = false;

    let error: boolean = false;
    let errorMessage: string = "Napaka pri podpisu"

    if(data && data.Metadata && data.Metadata.ServerMessageMetadata && data.Metadata.ServerMessageMetadata.MessageType){
      if(data.Metadata.ServerMessageMetadata.MessageType == 2){
        error = true;
        if(data.Metadata.ServerMessageMetadata.Message){
          errorMessage = data.Metadata.ServerMessageMetadata.Message;
        }
      }
    }

    if(error){
      const dialogRef = this.dialog.open(SemConfirmDialogComponent, { data: { cssclass: "conf-error", type: DialogType.NotificationSuccess, text: errorMessage } });
      
      dialogRef.afterClosed().subscribe(result => {
        DynamicLoadingUtil.loader.refresh(false);
        window.location.reload();
      });

    }else{
      if(!this.sucessLabel || this.sucessLabel.length == 0){
        this.sucessLabel = "Vloga uspešno podpisana in oddana. Preusmerili vas bomo na pogled vloge.";
      }
      const dialogRef = this.dialog.open(SemConfirmDialogComponent, { data: { cssclass: "conf-success", type: DialogType.NotificationSuccess, text: this.sucessLabel } });
  
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 1);
  
      dialogRef.afterClosed().subscribe(result => {
        DynamicLoadingUtil.loader.refresh(false);
        window.location.reload();
      });
  
      this.refCD.emit("");
      this.changeDetection.detectChanges();
    }    

  }

  blob2base64 = (blob, mimeType) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const dataUrlPrefix = `data:${mimeType};base64,`;
        const base64WithDataUrlPrefix = reader.result as string;
        let base64 = "";
        if (base64WithDataUrlPrefix) {
          base64 = base64WithDataUrlPrefix.replace(dataUrlPrefix, '');
        }
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  sendBatchUpdate(data:any){
    this.drawn = true;
    this.message = "";
  }

  public changeOptions(): void {
    this.canvasOptions = {
      ...this.canvasOptions,
      fillColorPickerEnabled: false,
      colorPickerEnabled: false
    };
  }
}